import React, { ComponentProps, FC } from 'react';

import Button from '@adsk/alloy-react-button';
import Modal from '@adsk/alloy-react-modal';

import { useTranslation } from '../../i18n';

export const AttachmentsTooManyFilesModal: FC<
  ComponentProps<typeof Modal> & {
    maxNumberOfAttachments?: number;
  }
> = ({ maxNumberOfAttachments, ...modalProps }) => {
  const { t } = useTranslation();
  const { onClose } = modalProps;

  return (
    <Modal {...modalProps} style={{ height: 'auto' }}>
      <Modal.Header>
        {t('MAX_ATTACHMENTS_REACHED', { maxNumberOfAttachments })}
      </Modal.Header>
      <Modal.Body style={{ padding: '24px' }}>
        {t('YOU_CAN_UPLOAD_UP_TO_ATTACHMENTS', {
          maxNumberOfAttachments,
        })}
      </Modal.Body>
      <Modal.Footer style={{ borderTop: 'none' }}>
        <Button variant={Button.VARIANTS.PRIMARY} onClick={onClose}>
          {t('CANCEL')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
